import React from "react"
import DataTable from "aldoo-ra/DataTable"
import Typography from "aldoo-ra/Typography"
import { ListReceiveLinks } from "./api"
import { StatusBadge, formatDate, Owner } from "./ui"

const ReceiveLinksTab = () => {
  const columns = [
    {
      id: "name",
      header: "Receive link",
      sortable: true,
      render: (_, item) => (
        <div className="flex flex-col leading-tight">
          <span className="font-medium">{item.name || "Untitled"}</span>
          <span className="text-xs text-admin_text_secondary break-all">/{item.token}</span>
        </div>
      ),
    },
    {
      id: "owner",
      header: "Owner",
      render: (_, item) => <Owner owner={item.owner} />,
    },
    {
      id: "status",
      header: "Status",
      sortable: true,
      render: (_, item) => <StatusBadge status={item.status} />,
    },
    {
      id: "access_type",
      header: "Access",
      render: (_, item) => <span className="capitalize text-admin_text_secondary">{item.access_type || "—"}</span>,
    },
    {
      id: "transfers",
      header: "Transfers",
      sortable: true,
      render: (_, item) => (
        <span className="text-admin_text_secondary">
          {item.transfers_used}
          {item.max_transfers != null ? ` / ${item.max_transfers}` : ""}
        </span>
      ),
    },
    {
      id: "retention",
      header: "Retention",
      render: (_, item) => (
        <span className="text-admin_text_secondary whitespace-nowrap">
          {item.retention_days != null ? `${item.retention_days}d` : "—"}
        </span>
      ),
    },
    {
      id: "created",
      header: "Created",
      sortable: true,
      render: (_, item) => <span className="whitespace-nowrap">{formatDate(item.created)}</span>,
    },
    {
      id: "expires",
      header: "Expires",
      sortable: true,
      render: (_, item) => <span className="whitespace-nowrap">{formatDate(item.link_expires_at)}</span>,
    },
  ]

  return (
    <DataTable
      variant="admin_browser"
      apiMethod={ListReceiveLinks}
      searchField="q"
      searchPlaceholder="Search name, token, owner…"
      sort={{ created: -1 }}
      localUserPreferencesKey="admin.transferBrowser.receiveLinks"
      renders={columns}
      preferredHeight="60vh"
      itemHeight="h-14"
      noData={<Typography variant="admin_body">No receive links found</Typography>}
    />
  )
}

export default ReceiveLinksTab
